// extracted by mini-css-extract-plugin
module.exports = {"container":"allocateMembers_container__fVSMq","content":"allocateMembers_content__2Fh7t"};